import { Component, Host, Prop, h } from '@stencil/core';

import { onShiftDigitalAnalyticsInit, onShiftDigitalAnalyticsRemoved } from '../../actions/actions.shift-digital-analytics';

@Component({
  tag: 'ico-analytics-shift-digital',
})
export class AnalyticsShiftDigital {
  @Prop() container: string = '';
  @Prop() oemDealerCode: string = '';

  connectedCallback() {
    onShiftDigitalAnalyticsInit(this.container, this.oemDealerCode);
  }
  disconnectedCallback() {
    onShiftDigitalAnalyticsRemoved();
  }

  render() {
    return <Host></Host>;
  }
}
